import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/app/global-error.tsx");
